// src/utils/rientroMaterialiConstants.js
// Costanti condivise tra ListinoMaterialiPage (dove si personalizzano) e RientroMaterialiPage
// (dove si usano). Separate in un file a parte per evitare import circolari tra le due pagine.

// Seed iniziale generico (installazione/manutenzione impiantistica elettrica ed edile) — Nexiora
// sarà usata da aziende diverse, ognuna con il proprio parco mezzi e le proprie casistiche di
// reso, quindi queste sono solo il punto di partenza: ogni organizzazione le personalizza da
// Acquisti → Listino Materiali → "Tipi di reso e automezzi". Non è un valore fisso uguale per tutti.
export const DEFAULT_TIPO_RESO = [
  "Fine lavori / materiale in eccesso",
  "Materiale non conforme o difettoso",
  "Errore di approvvigionamento",
  "Cambio specifiche di progetto",
  "Chiusura o annullamento commessa",
  "Riutilizzo su altra commessa",
  "Reso al fornitore",
  "Materiale a noleggio da restituire",
  "Altro",
];
export const DEFAULT_AUTOMEZZO_SUGGERITO = [
  "Auto",
  "Furgone",
  "Furgone con rimorchio",
  "Autocarro",
  "Autocarro con gru / sponda idraulica",
  "Mezzo del cliente/cantiere",
  "Da valutare",
];
// Checklist logistica abbastanza universale (chiunque ritiri materiale da un cantiere si pone
// più o meno queste domande) — resta fissa per non moltiplicare le liste da configurare.
export const TEMPISTICHE = ["Bassa","Media","Alta"];
export const CONDIZIONI_RITIRO = [
  "Materiale già raccolto e pronto",
  "Necessario personale di supporto",
  "Presenza di materiale ingombrante",
  "Materiale da individuare",
  "Necessario mezzo con gru",
  "Presenza di materiale da smaltire",
  "Altro",
];
